<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <q-modal
      v-model="modalEditar"
      :content-css="{minWidth: '70vw'}"
    >
      <q-card-main>
        <div class="q-card gvn-cabecalho mrg-b-10">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Nº do Processo / Ano: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.numProcesso}}/{{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.anoProcesso}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Nº Protocolo: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.numProtocolo}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Rota / Sequência: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.roteiro.numRota}}
              /{{this.newPaginaStatusMovimentacao.movimentacaoProcesso.numSequencia}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Tipo de Processo: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.tipoProcesso.desTipoProcesso}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Assunto: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.subassunto.assunto.desAssunto}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Requerente: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.requerente.nomRequerente}}
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Subassunto: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.aberturaProcesso.subassunto.desSubassunto}}
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Local de origem </strong>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <strong>Órgão: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.setor.unidade.orgao.desOrgao}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Unidade: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.setor.unidade.desUnidade}}
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>Setor: </strong>
              {{this.newPaginaStatusMovimentacao.movimentacaoProcesso.setor.desSetor}}
            </div>
          </div>
        </div>
        <div class="titulo-card">
          Histórico de movimentação
        </div>
        <table
          class="col-md-12"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th
                class="text-left"
                width="5%"
              >Mov.</th>
              <th
                class="text-left"
                width="15%"
              >Responsável</th>
              <th
                class="text-left"
                width="20%"
              >Órgão</th>
              <th
                class="text-left"
                width="20%"
              >Unidade</th>
              <th
                class="text-left"
                width="20%"
              >Setor</th>
              <th
                class="text-right"
                width="5%"
              ></th>
              <th
                class="text-right"
                width="5%"
              ></th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="mov in arrayMovimentos"
              v-bind:key="mov.a"
            >
              <td class="text-left">
                {{mov.numSequencia}}
              </td>
              <td class="text-left">
                {{mov.responsavelMovimento.usuario.nomUsuario}}
              </td>
              <td class="text-left">
                {{mov.setor.unidade.orgao.desOrgao}}
              </td>
              <td class="text-left">
                {{mov.setor.unidade.desUnidade}}
              </td>
              <td class="text-left">
                {{mov.setor.desSetor}}
              </td>

              <td class="text-right">
                <q-tooltip>Visualizar</q-tooltip>
                <button
                  class="btn-grid-secundario"
                  @click="visualizarMovimento(mov.codMovimentacao)"
                ><i class="q-icon  fas fa-search"></i>
                </button>
              </td>
              <td>
                <q-tooltip>Imprimir comprovante de movimentação</q-tooltip>
                <button
                  class="btn-grid-preto"
                  @click="imprimirMovimento(mov.codMovimentacao)"
                ><i class="q-icon  fas fa-print"></i>
                </button>
              </td>
            </tr>

          </tbody>

        </table>
        <br />
        <div class="row center">
          <div class="titulo-notificacao">
            <i class="titulo-icone fas fa-exclamation"></i>
            Este processo não pode ser editado pois foi feito mais de uma movimentação.
          </div>
        </div>
        <div class="col-sm-6 text-right">
          <q-btn
            id="Fechar"
            name="Fechar"
            color="tertiary"
            @click="modalEditar = false"
            label="Fechar"
          >
          </q-btn>

        </div>

      </q-card-main>
    </q-modal>
    <g-pesquisa
      id="refResultadoPesquisaAberturaProcesso"
      name="refResultadoPesquisaAberturaProcesso"
      ref="refResultadoPesquisaAberturaProcesso"
      :filtroAdicional="getFiltroPesquisa"
      :limparFiltroLocal="limparFiltro"
      :colunasPropriedade=colunasAberturaProcessoDataTable
      :apiPesquisa="apiaberturaProcesso"
      :operacoes="operacoes"
      :exibirColunaOperacoes="exibirColunaOperacoes"
      :operacoesQFab="operacoesQFab"
      :exibirColunaOperacoesQFab="true"
      :elementosPorPagina="elementosPorPagina"
      :novo="abrirPaginaAberturaProcessoCadastrar"
      :imprimir="imprimir"
      :showTermoPesquisa="false"
      :showBuscaAvancadaAberta="true"
      :carregamentoInicial="false"
      :showBotaoNovo="permissaoPerfil.incluir"
    >
      <div class="row">
        <div class="col-sm-2 col-xs-2">
          <g-input
            id="refNumProcessoInicial"
            name="refNumProcessoInicial"
            ref="refNumProcessoInicial"
            validacao="Number"
            mascara="numero"
            :tamanho="10"
            etiqueta="Nº Processo Inicial"
            :foco="false"
            v-model="aberturaProcesso.numProcesso"
            @input="alterouNumProcesso"
          >
          </g-input>
        </div>
        <div class="col-sm-2 col-xs-2">
          <g-input
            id="refNumProcessoFinal"
            name="refNumProcessoFinal"
            ref="refNumProcessoFinal"
            validacao="Number"
            mascara="numero"
            :tamanho="10"
            etiqueta="Nº Processo Final"
            :foco="false"
            v-model="numProcessoFinal"
          >
          </g-input>
        </div>
        <div
          class="col-sm-2 col-xs-2"
          style="padding-right: 30px;"
        >
          <g-dateInput
            id="refDatAtualizacao"
            name="refDatAtualizacao"
            ref="refDatAtualizacao"
            etiqueta="Data Atualização Inicial"
            v-model="datAtualizacao"
            :desabilitar="false"
            :somenteLeitura="paginaStatus.desabilitarEdicao"
            :dataMax="new Date()"
          >
          </g-dateInput>
        </div>
        <div
          class="col-sm-2 col-xs-2"
          style="padding-right: 30px;"
        >
          <g-dateInput
            id="refDatAtualizacaoFinal"
            name="refDatAtualizacaoFinal"
            ref="refDatAtualizacaoFinal"
            etiqueta="Data Atualização Final"
            v-model="datAtualizacaoFinal"
            :desabilitar="false"
            :somenteLeitura="paginaStatus.desabilitarEdicao"
            :dataMax="new Date()"
          >
          </g-dateInput>
        </div>
        <div class="col-sm-4 col-xs-4">
          <q-select
            multiple
            chips
            stack-label="Status Atual"
            color="primary"
            v-model="StatusProcesso"
            :options="statusProcessoArray"
            style="margin: 0 10px 0 0;"
            @input="alterouStatusProcesso"
          />
        </div>
        <!-- <div class="col-sm-3 col-xs-3">
          <g-input
            id="refAnoProcessoInicial"
            name="refAnoProcessoInicial"
            ref="refAnoProcessoInicial"
            validacao="Number"
            mascara="numero"
            :tamanho="4"
            etiqueta="Ano Processo Inicial"
            :foco="false"
            v-model="aberturaProcesso.anoProcesso"
          >
          </g-input>
        </div>
        <div class="col-sm-3 col-xs-3">
          <g-input
            id="refAnoProcessoFinal"
            name="refAnoProcessoFinal"
            ref="refAnoProcessoFinal"
            validacao="Number"
            mascara="numero"
            :tamanho="4"
            etiqueta="Ano Processo Final"
            :foco="false"
            v-model="anoProcessoFinal"
          >
          </g-input>
        </div> -->
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-6">
          <g-autocomplete
            id="refAssunto"
            name="refAssunto"
            ref="refAssunto"
            etiqueta="Assunto"
            valor="codAssunto"
            descricaoPrimaria="desAssunto"
            :foco="false"
            :api=apiAssunto
            v-model="aberturaProcesso.codAssunto"
          >
          </g-autocomplete>
        </div>
        <div class="col-sm-6 col-xs-6">
          <g-autocomplete
            id="refSubAssunto"
            name="refSubAssunto"
            ref="refSubAssunto"
            etiqueta="Subassunto"
            valor="codSubassunto"
            descricaoPrimaria="desSubassunto"
            :api="aberturaProcesso.codAssunto !== '' ? apiSubAssuntoTermo : apiSubAssunto"
            :foco="false"
            :filtroAdicional="getFiltroSubassunto"
            v-model="aberturaProcesso.codSubassunto"
          >
          </g-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-6">
          <g-autocomplete
            id="refRequerente"
            name="refRequerente"
            ref="refRequerente"
            etiqueta="Requerente"
            valor="codRequerente"
            :foco="false"
            descricaoPrimaria="nomeDataNascimentoDocumento"
            :desabilitar="paginaStatus.desabilitarEdicao"
            :api=apiRequerente
            :filtroAdicional="getFiltroRequerente"
            v-model="aberturaProcesso.requerente.codRequerente"
          >
          </g-autocomplete>
        </div>

        <div class="col-sm-3 col-xs-3">
          <g-autocomplete
            id="refSituacao"
            name="refSituacao"
            ref="refSituacao"
            valor="desSituacao"
            etiqueta="Situação"
            descricaoPrimaria="desSituacao"
            :api=apiSituacao
            :foco="false"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="desSituacao"
          >
          </g-autocomplete>
        </div>
        <div class="col-sm-3 col-xs-3">
          <g-input
            id="refNotaFiscal"
            name="refNotaFiscal"
            ref="refNotaFiscal"
            validacao="Number"
            :tamanho="40"
            etiqueta="Nota Fiscal"
            :foco="false"
            v-model="aberturaProcesso.txtNotaFiscal"
          >
          </g-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 col-xs-2">
          <q-checkbox
            v-model="indPendenteConfirmacao"
            color="primary"
            label="Pendente de confirmação"
          />
        </div>
        <div class="col-sm-2 col-xs-2">
          <q-checkbox
            v-model="indPendencia"
            color="primary"
            label="Processo com Pendência"
          />
        </div>
        <div class="col-sm-2 col-xs-2">
          <q-checkbox
            v-model="indPendenciaComAnexo"
            color="primary"
            label="Retorno Pendência Externa"
          />
        </div>
        <div class="col-sm-2 col-xs-2">
          <q-checkbox
            v-model="indEstornado"
            color="primary"
            label="Processo Estornado"
          />
        </div>
      </div>
      <br />

    </g-pesquisa>
    <g-fab :ajudas="ajudaOperacoes" />
  </div>
</template>

<script>
import api from 'components/util/api'
import msg from 'components/util/msg'
import util from 'components/util/util'
import GPesquisa from 'components/util/gPesquisa'
import GAutocomplete from 'components/util/gAutocomplete'
import GSelect from 'components/util/gSelect'
import GInput from 'components/util/gInput'
import GFab from 'components/util/gFab'
import utilHttp from 'components/util/utilHttp'
import GDatepicker from 'components/util/gDatepicker'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GDateInput from 'components/util/gDateInput'

export default {
  data () {
    return {
      chaveLocalStorage: 'paginaStatus',
      permissaoPerfil: '',
      variavel: '',
      apiRelatorioMovimentacaoProcesso: api.RELATORIO_MOVIMENTACAO_PROCESSO,
      apiImprimirRelatorio: api.RELATORIO_COMPROVANTE_ENCAMINHAMENTO,
      apiaberturaProcesso: api.ABERTURA_PROCESSO,
      apiSubAssunto: api.SUB_ASSUNTO.concat('/todos'),
      apiSubAssuntoTermo: api.SUB_ASSUNTO_COD_ASSUNTO,
      apiRequerente: api.REQUERENTE,
      apiSituacao: api.SITUACAO,
      apiAssunto: api.ASSUNTO,
      desabilitarSubAssunto: false,
      exibirColunaOperacoes: true,
      desabilitarAssunto: false,
      elementosPorPagina: 10,
      modalEditar: false,
      parametrosSistema: '',
      nomeDataNascimentoDocumento: '',
      nomeComprovanteMovimento: '',
      datAtualizacaoFinal: '',
      numProcessoFinal: '',
      anoProcessoFinal: '',
      StatusProcesso: ['TOD'],
      datAtualizacao: '',
      anoProcesso: '',
      numProcesso: '',
      dataInicial: '',
      desSituacao: '',
      dataFinal: '',
      situacao: {},
      arrayMovimentos: [],
      msgEstorno: false,
      indPendenteConfirmacao: false,
      indPendencia: false,
      indPendenciaComAnexo: false,
      indEstornado: false,
      statusProcessoArray: [
        { value: 'TOD', label: 'TODOS' },
        { value: 'ABE', label: 'ABERTO' },
        { value: 'MOV', label: 'MOVIMENTADO' },
        { value: 'ENC', label: 'ENCERRADO' },
        { value: 'ARQ', label: 'ARQUIVADO' },
        { value: 'CAN', label: 'CANCELADO' }
      ],
      aberturaProcesso: {
        codAssunto: '',
        requerente: {}
      },
      confirmacaoMovimentacaoProcesso: {},
      pendenciaProcesso: {},
      newPaginaStatusMovimentacao: {
        movimentacaoProcesso: {
          setor: {
            unidade: {
              orgao: {}
            }
          },
          aberturaProcesso: {
            tipoProcesso: {},
            subassunto: {
              assunto: {}
            },
            requerente: {},

            roteiro: {}
          }
        }
      },
      paginaStatus: {
        nomeDataNascimentoDocumento: '',
        aberturaProcesso: {
          formaSolicitacao: {},
          justificativa: {},
          tipoProcesso: {},
          subassunto: { assunto: {} },
          roteiro: {}
        },
        documentoAnexoProcessoSalvarList: [],
        documentoAnexoProcessoExcluirList: [],
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunasAberturaProcessoDataTable: [

        {
          conteudoTipo: '',
          largura: '5%',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          cabecalhoEtiqueta: 'Processo',
          propriedade: 'aberturaProcesso.numProcesso',
          chave: 'aberturaProcesso.numProcesso'
        },

        {
          conteudoTipo: 'icone2',
          largura: '0%',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          celulaClasse1: 'fas fa-registered',
          celulaClasse2: 'fas fa-layer-group',
          conteudoIconeTamanho: '15px',
          conteudoTooltip1: 'Esse processo faz parte de uma remessa.',
          conteudoTooltip2: 'Esse processo faz parte de uma junção.',
          cor: 'blue',
          valor1: (row) => this.habilitarRemessa(row),
          valor2: (row) => this.habilitarJuncao(row)
        },
        {
          conteudoTipo: '',
          largura: '6%',
          cabecalhoClasse: 'text-center',
          cabecalhoEtiqueta: 'Ano',
          conteudoClasse: 'text-center',
          propriedade: 'aberturaProcesso.anoProcesso'
          //  chave: 'aberturaProcesso.anoProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status Atual',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.indStatusProcesso'
          //  chave: 'aberturaProcesso.indStatusProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data Atualização',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.datCriacaoOuAlteracao',
          // chave: 'aberturaProcesso.datAtualizacao',
          formatar: (valor) => this.formatarDataAtualizacao(valor)
        },
        {
          conteudoTipo: '',
          largura: '18%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.requerente.nomRequerente'
          // chave: 'aberturaProcesso.requerente.nomRequerente'
        },
        {
          conteudoTipo: '',
          largura: '18%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Subassunto',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.subassunto.desSubassunto',
          chave: 'aberturaProcesso.subassunto.desSubassunto'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Situação',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.desSituacao'
          // chave: 'movimentacaoProcesso.situacao.desSituacao'
        },
        {
          conteudoTipo: '',
          largura: '5%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Pendente',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.indPendencia',
          formatar: (valor) => this.formatarSimNao(valor)
        }
      ],
      operacoes: [
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar',
          clique: this.visualizarItem,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'orange',
          icone: 'fas fa-edit',
          tooltip: 'Editar',
          clique: this.editarItem,
          permissao: (row) => this.permissaoPerfil.alterar,
          visivel: (row) => this.permissaoPerfil.alterar
        }
      ],
      operacoesQFab: [

        {
          cor: 'grey',
          icone: 'fas fa-paperclip',
          tooltip: 'Anexar Documentos',
          clique: this.anexarDocumentoProcesso,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'negative',
          icone: 'fas fa-ban',
          tooltip: 'Cancelar Processo',
          clique: this.cancelarProcessoCadastrar,
          permissao: (row) => true,
          visivel: (row) => this.habilitarCancelamentoProcesso(row)
        },
        {
          cor: 'red',
          icone: 'far fa-times-circle',
          tooltip: 'Encerrar Processo',
          clique: this.encerramentoDoProcesso,
          permissao: (row) => true,
          visivel: (row) => this.buscarProcessosMovimentados(row)
        },
        {
          cor: 'green-10',
          icone: 'fas fa-check',
          tooltip: 'Confirmar Movimentação de Processo',
          clique: this.confirmacaoMovimentacaoProcessoCadastrar,
          permissao: (row) => true,
          visivel: (row) => this.habilitarConfirmacaoMovimentoProcesso(row)
        },
        {
          cor: 'positive',
          tooltip: 'Movimentar Processo',
          clique: this.movimentacaoProcessoCadastrar,
          permissao: (row) => true,
          visivel: (row) => this.habilitarMovimentacaoProcesso(row),
          icone: 'fas fa-exchange-alt'
        },
        {
          cor: 'brown',
          icone: 'fas fa-archive',
          tooltip: 'Arquivar Processo',
          clique: this.arquivamentoDoProcesso,
          permissao: (row) => true,
          visivel: (row) => this.buscarProcessosEncerrados(row)
        },
        {
          cor: 'dark',
          icone: 'far fa-file-alt',
          tooltip: 'Observações Gerais do Processo',
          clique: this.observacaoGeralDoProcesso,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'green',
          icone: 'fas fa-sync',
          tooltip: 'Alterar Situação do Processo',
          clique: this.movimentacaoSituacaoProcesso,
          permissao: (row) => true,
          visivel: (row) => this.habilitarAlterarSituacao(row)
        },
        {
          cor: 'deep-orange',
          icone: 'fas fa-tasks',
          tooltip: 'Pendências do Processo',
          clique: this.pendenciaProcessoCadastrar,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'secondary',
          tooltip: 'Estornar Movimentação',
          clique: this.movimentacaoProcessoCadastrar,
          permissao: (row) => true,
          visivel: (row) => this.habilitaEstornoMovimentacao(row),
          icone: 'fas fa-undo-alt'
        },
        {
          cor: 'black',
          icone: 'fas fa-registered',
          tooltip: 'Remessa',
          clique: this.abrirTelaRemessa,
          permissao: (row) => true,
          visivel: (row) => this.habilitarRemessa(row)
        },
        {
          cor: 'brown-10',
          icone: 'fas fa-layer-group',
          tooltip: 'Junção',
          clique: this.abrirTelaJuncao,
          permissao: (row) => true,
          visivel: (row) => this.habilitarJuncao(row)
        }
        // {
        //   cor: 'primary',
        //   icone: 'fas fa-history',
        //   tooltip: 'Histórico',
        //   clique: this.imprimirHistorico,
        //   permissao: (row) => true,
        //   visivel: (row) => true
        // },
        // {
        //   cor: 'purple-4',
        //   icone: 'fa fa-print',
        //   tooltip: 'Imprimir comprovante de encaminhamento',
        //   clique: this.imprimirComprovanteEncaminhamento,
        //   permissao: (row) => true,
        //   visivel: (row) => true
        // }
      ],
      ajudaOperacoes: [
        {
          cor: 'orange',
          icone: 'fas fa-edit',
          tituloTexto: 'Editar Processo',
          descricao: 'Você pode editar as informações de um processo caso o status dele seja igual à "Aberto". Caso o processo tenha o status diferente de "Aberto" será exibido o histórico de movimentações do processo.'
        },
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tituloTexto: 'Visualizar Processo',
          descricao: 'Você pode a qualquer momento (independente do status) visualizar os dados informados na abertura de um processo mais o histórico de movimentações do processo.'
        },
        {
          cor: 'grey',
          icone: 'fas fa-paperclip',
          tituloTexto: 'Anexar Documentos',
          descricao: 'Você pode a qualquer momento (independente do status) anexar documentos a um processo, além de visualizar e baixar aqueles documentos já anexados.'
        },
        {
          cor: 'negative',
          icone: 'fas fa-ban',
          tituloTexto: 'Cancelar Processo',
          descricao: 'Você pode cancelar um processo definindo que ele não será mais tramitado. Um processo só pode ser cancelado caso o status dele seja igual à "Aberto" ou o status seja igual à "Movimentado" e o recebimento da movimentação tenha sido confirmada.'
        },
        {
          cor: 'red',
          icone: 'far fa-times-circle',
          tituloTexto: 'Encerrar Processo',
          descricao: 'Você pode encerrar um processo definindo que ele chegou ao final da sua tramitação. Um processo só pode ser encerrado caso o status dele seja igual à "Movimentado" e o recebimento da movimentação tenha sido confirmada.'
        },
        {
          cor: 'green-10',
          icone: 'fas fa-check',
          tituloTexto: 'Confirmar Movimentação de Processo',
          descricao: 'Você pode confirmar o recebimento de um processo. O recebimento de um processo só pode ser confirmado caso o status do processo seja igual à "Movimentado" e a sua movimentação ainda não tenha sido confirmada.'
        },
        {
          cor: 'positive',
          icone: 'fas fa-exchange-alt',
          tituloTexto: 'Movimentar Processo',
          descricao: 'Você pode movimentar um processo definindo um destino para ele. Um processo só pode ser movimentado caso o status dele seja igual à "Aberto" ou o status seja igual à "Movimentado" e o recebimento da movimentação anterior tenha sido confirmada.'
        },
        {
          cor: 'brown',
          icone: 'fas fa-archive',
          tituloTexto: 'Arquivar Processo',
          descricao: 'Você pode arquivar um processo informando a sua localização física. Um processo só pode ser arquivado caso o status dele seja igual à "Encerrado".'
        },
        {
          cor: 'dark',
          icone: 'far fa-file-alt',
          tituloTexto: 'Observações Gerais do Processo',
          descricao: 'Você pode a qualquer momento (independente do status) informar observações gerais para um processo, além de visualizar as observações já informadas.'
        },
        {
          cor: 'green',
          icone: 'fas fa-sync',
          tituloTexto: 'Alterar Situação do Processo',
          descricao: 'Você pode a qualquer momento (independente do status) alterar a situação de um processo, desde que o processo não faça parte de uma Junção de Processo como "Secundário".'
        },
        {
          cor: 'deep-orange',
          icone: 'fas fa-tasks',
          tituloTexto: 'Pendências do Processo',
          descricao: 'Você pode a qualquer momento (independente do status) informar pendências para um processo, além de visualizar as pendências já informadas.'
        },
        {
          cor: 'secondary',
          icone: 'fas fa-undo-alt',
          tituloTexto: 'Estornar Movimentação',
          descricao: 'Você pode estornar (desfazer) a última movimentação do processo. Um processo só pode ser estornado caso o status dele seja igual à "Movimentado".'
        },
        {
          cor: 'black',
          icone: 'fas fa-registered',
          tituloTexto: 'Visualizar Remessa de Processo',
          descricao: 'O ícone no grid identifica que o processo faz parte de uma remessa de processos. O botão direciona o usuário para a tela de Remessa.'
        },
        {
          cor: 'brown-10',
          icone: 'fas fa-layer-group',
          tituloTexto: 'Visualizar Junção de Processo',
          descricao: 'O ícone no grid identifica que o processo faz parte de uma junção de processo. O botão direciona o usuário para a tela de Junção de Processo.'
        },
        {
          cor: 'primary',
          icone: 'fa fa-print',
          tituloTexto: 'Imprimir histórico',
          descricao: 'O botão imprime o histórico do processo.'
        }
      ]
    }
  },
  methods: {
    formatarSimNao (valor) {
      if (valor === 'S') {
        return 'Sim'
      } else {
        return 'Não'
      }
    },
    formatarDataAtualizacao (valor) {
      if (valor) {
        let hora = valor.substring(11, 16)
        let data = util.formatarData(valor, 'dd/mm/yyyy')
        return data + ' ' + hora
      } else {
        return ''
      }
    },
    getFiltroSubassunto () {
      if (this.aberturaProcesso.codAssunto) {
        return '/'.concat(this.aberturaProcesso.codAssunto)
      }
    },
    getFiltroRequerente () {
      if (this.$login.getCliente().nomCliente.includes('Araxá')) {
        return '/Araxá'
      } else {
        return '/outro'
      }
    },
    imprimirMovimento (codMovimentacao) {
      var self = this
      let url = ''
      url = self.apiRelatorioMovimentacaoProcesso.concat('?codMovimentacao=').concat(codMovimentacao)
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteMovimento=').concat(self.nomeComprovanteMovimento)
      utilHttp.httpGet(url, resposta => {
        window.open(url)
      })
    },
    imprimirHistorico (objeto) {
      var self = this
      self.paginaStatus.aberturaProcesso = objeto.aberturaProcesso
      if (!self.paginaStatus.aberturaProcesso.representante) {
        self.paginaStatus.aberturaProcesso.representante = ''
      }
      self.paginaStatus.desabilitarEdicao = true
      self.paginaStatus.operacao = {
        descricao: 'Histórico',
        icone: 'fas fa-history'
      }
      self.$router.push({
        name: 'aberturaProcessoVisualizar',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    imprimirComprovanteEncaminhamento (objeto) {
      var self = this
      let url = ''
      url = self.apiImprimirRelatorio.concat('?codProcesso=').concat(objeto.aberturaProcesso.codProcesso.toString())
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      window.open(url)
    },
    buscarParametrosSistema () {
      var self = this
      utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          self.parametrosSistema = resposta.body
        }
      })
    },
    habilitarRemessa (item) {
      if (item.aberturaProcesso.existeRemessa) {
        return true
      } else {
        return false
      }
    },
    habilitarJuncao (item) {
      if (item.aberturaProcesso.existeJuncao) {
        return true
      }

      return false
    },
    abrirTelaRemessa (item) {
      item = item.movimentacaoProcesso

      var newPaginaStatus = {
        remessaProcesso: {
          movimentacaoProcesso: {
            situacao: {},
            responsavelMovimento: { usuario: {} },
            responsavelConfirmacao: { usuario: {} },
            setor: { unidade: { orgao: {} } },
            setorConfirmacao: { unidade: { orgao: {} } },
            aberturaProcesso: {
              responsavel: { usuario: {} },
              representante: { usuario: {} },
              formaSolicitacao: {},
              tipoProcesso: {},
              subassunto: { assunto: {} },
              roteiro: { setor: { unidade: { orgao: {} } } },
              requerente: {},
              justificativa: {}
            }
          }
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Visualizar',
        icone: 'fa fa-search'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = true

      var filtro1 = ''
        .concat('?codMovimentacao=').concat(item.codMovimentacao)
      utilHttp.httpGet(api.BUSCAR_REMESSA_PROCESSO_PELA_MOVIMENTACAO.concat(filtro1), resposta => {
        newPaginaStatus.remessaProcesso = resposta.body

        var filtro = ''
          .concat('?numRemessa=').concat(newPaginaStatus.remessaProcesso.numRemessa)
          .concat('&anoRemessa=').concat(newPaginaStatus.remessaProcesso.anoRemessa)
        utilHttp.httpGet(api.BUSCAR_REMESSA_PROCESSO_A_CONFIRMAR.concat(filtro), resposta => {
          newPaginaStatus.remessaProcesso = resposta.body
          this.$router.push({
            name: 'remessaProcessoConfirmacao',
            params: {
              paginaStatus: newPaginaStatus
            }
          })
        })
      })
    },
    abrirTelaJuncao (item) {
      item = item.movimentacaoProcesso
      var newPaginaStatus = {
        juncaoProcesso: {
          movimentacaoProcesso: {
            setor: {
              unidade: {
                orgao: {}
              }
            },
            aberturaProcesso: {
              tipoProcesso: {},
              subassunto: {
                assunto: {}
              },
              requerente: {},

              roteiro: {}
            }
          }
        }
      }

      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = true
      var filtro = ''
        .concat('?codProcesso=').concat(item.aberturaProcesso.codProcesso)
        .concat('&indSituacao=').concat('S')
      utilHttp.httpGet(api.JUNCAO_DE_PROCESSOS_BUSCAR_COD_PROCESSO_IND_SITUACAO.concat(filtro), resposta => {
        newPaginaStatus.juncaoProcesso = resposta.body

        newPaginaStatus.desabilitarEdicao = true
        newPaginaStatus.operacao = {
          descricao: 'Visualizar Junção de Processo',
          icone: 'fa fa-search'
        }
        this.$router.push({
          name: 'juncaoProcessoVisualizar',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    visualizarMovimento (codMovimentacao) {
      var self = this

      utilHttp.httpGet(api.MOVIMENTACAO_PROCESSO.concat('/').concat(codMovimentacao), resposta => {
        self.visualizarMovimentacao(resposta.body)
      })
    },
    visualizarMovimentacao (item) {
      this.paginaStatus.movimentacaoProcesso = item
      this.paginaStatus.desabilitarEdicao = true
      this.paginaStatus.operacao = {
        descricao: 'Visualizar',
        icone: 'fa fa-search'
      }
      this.$router.push({
        name: 'movimentacaoProcessoVisualizar',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    limparFiltro () {
      var self = this
      self.StatusProcesso = ['TOD']
      self.aberturaProcesso.numProcesso = ''
      self.numProcessoFinal = ''
      self.anoProcessoFinal = ''

      self.datAtualizacao = '01/01/'.concat(new Date().getFullYear())
      var datAtual = new Date()
      self.datAtualizacaoFinal = util.formatarDiaMesAno(datAtual.toJSON())

      self.aberturaProcesso.requerente.codRequerente = ''
      self.situacao.codSituacao = ''
      self.desSituacao = ''
      self.aberturaProcesso.txtNotaFiscal = ''
      self.$refs['refRequerente'].limpar()
      self.$refs['refSituacao'].limpar()

      self.$refs['refSubAssunto'].limpar()
      self.$refs['refAssunto'].limpar()
      self.aberturaProcesso.requerente = {}
      self.situacao = {}
      self.aberturaProcesso = {
        codAssunto: '',
        requerente: {}
      }
      self.aberturaProcesso.anoProcesso = new Date().getFullYear()
      self.anoProcessoFinal = new Date().getFullYear()
      self.indPendenteConfirmacao = false
      self.indPendencia = false
      self.indPendenciaComAnexo = false
      self.indEstornado = false

      util.adicionarNoStorage('filtroAberturaProcesso', '')
    },
    visibilidade () {
      if (this.variavel === true) {
        return true
      } else { return false }
    },
    getFiltroPesquisa () {
      var filtro = ''
      var self = this

      self.tratarDataInicial()
      self.tratarDataFinal()

      if (self.datAtualizacao && self.datAtualizacaoFinal) {
        if (self.dataFinal < self.dataInicial) {
          util.exibirToastAviso('Favor verificar a data informada')
        }
      }

      if (self.aberturaProcesso.numProcesso) filtro = filtro.concat('&numProcesso=').concat(self.aberturaProcesso.numProcesso)
      if (self.numProcessoFinal) filtro = filtro.concat('&numProcessoFinal=').concat(self.numProcessoFinal)

      if (self.datAtualizacao) filtro = filtro.concat('&datAtualizacao=').concat(self.dataInicial).concat('T00:00:00.000-00:00')
      if (self.datAtualizacaoFinal) filtro = filtro.concat('&datAtualizacaoFinal=').concat(self.dataFinal).concat('T23:59:59.999-05:00')

      if (self.aberturaProcesso.indStatusProcesso !== 'TOD') {
        if (self.aberturaProcesso.indStatusProcesso) filtro = filtro.concat('&indStatusProcesso=').concat(self.aberturaProcesso.indStatusProcesso)
      }

      if (self.aberturaProcesso.txtNotaFiscal) filtro = filtro.concat('&txtNotaFiscal=').concat(self.aberturaProcesso.txtNotaFiscal)

      if (self.desSituacao) {
        filtro = filtro.concat('&desSituacao=').concat(
          self.desSituacao === self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'codSituacao')
            ? self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'desSituacao')
            : self.desSituacao
        )

        filtro = filtro.concat('&codSituacao=').concat(
          self.$refs.refSituacao.objetoSelecionado.codSituacao
            ? self.$refs.refSituacao.objetoSelecionado.codSituacao
            : self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'codSituacao')
        )
      }

      if (self.$login.getCodUsuario()) filtro = filtro.concat('&codUsuario=').concat(self.$login.getCodUsuario())

      if (self.aberturaProcesso.requerente.codRequerente) {
        filtro = filtro.concat('&codRequerente=').concat(self.aberturaProcesso.requerente.codRequerente)
        // Cenário onde a descrição do requerente está no Storage e não foi alterado em tela.
        // ObjetoSelecionado não seta se não houver alteração no select do requerente.
        filtro = filtro.concat('&nomRequerente=').concat(
          self.$refs.refRequerente.objetoSelecionado.nomRequerente
            ? self.$refs.refRequerente.objetoSelecionado.nomRequerente
            : self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'nomRequerente')
        )
      }

      if (self.aberturaProcesso.codAssunto) {
        filtro = filtro.concat('&codAssunto=').concat(self.aberturaProcesso.codAssunto)

        // Cenário onde a descrição do assunto está no Storage e não foi alterado em tela.
        // ObjetoSelecionado não seta se não houver alteração nas opções de assunto.
        filtro = filtro.concat('&desAssunto=').concat(
          self.$refs.refAssunto.objetoSelecionado.desAssunto
            ? self.$refs.refAssunto.objetoSelecionado.desAssunto
            : self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'desAssunto')
        )
      }

      if (self.aberturaProcesso.codSubassunto) {
        filtro = filtro.concat('&codSubassunto=').concat(self.aberturaProcesso.codSubassunto)

        // Cenário onde a descrição do Subassunto está no Storage e não foi alterado em tela.
        // ObjetoSelecionado não seta se não houver alteração nas opções de Subassunto.
        filtro = filtro.concat('&desSubassunto=').concat(
          self.$refs.refSubAssunto.objetoSelecionado.desSubassunto
            ? self.$refs.refSubAssunto.objetoSelecionado.desSubassunto
            : self.getValorFiltroURLRecursivo(util.recuperarDoStorage('filtroAberturaProcesso'), 'desSubassunto')
        )
      }

      if (self.indPendenteConfirmacao) {
        filtro = filtro.concat('&pendenteConfirmacao=S')
      }
      if (self.indPendencia) {
        filtro = filtro.concat('&indPendencia=S')
      }
      if (self.indPendenciaComAnexo) {
        filtro = filtro.concat('&indPendenciaComAnexo=S')
      }
      if (self.indEstornado) {
        filtro = filtro.concat('&indEstornado=S')
      }
      util.adicionarNoStorage('filtroAberturaProcesso', filtro)
      util.adicionarNoStorage('pesquisarPaginaAbertura', 'S')
      return filtro
    },
    visualizarItem1 (item) {
      item = item.aberturaProcesso
      this.paginaStatus.aberturaProcesso = item
      if (!this.paginaStatus.aberturaProcesso.representante) {
        this.paginaStatus.aberturaProcesso.representante = ''
      }
      this.paginaStatus.desabilitarEdicao = true
      this.paginaStatus.operacao = {
        descricao: 'Visualizar',
        icone: 'fa fa-search'
      }
      this.$router.push({
        name: 'aberturaProcessoVisualizar',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    visualizarItem (item) {
      var self = this
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_DO_PROCESSO.concat('?codProcesso=').concat(item.aberturaProcesso.codProcesso), resposta => {
        item = item.aberturaProcesso
        self.paginaStatus.aberturaProcesso = item
        // self.paginaStatus.aberturaProcesso.requerente.nomeDataNascimentoDocumento = this.paginaStatus.aberturaProcesso.requerente.nomeDataNascimentoDocumento
        // this.paginaStatus.aberturaProcesso.representante.nomeDataNascimentoDocumento = this.paginaStatus.aberturaProcesso.representante.nomeDataNascimentoDocumento
        if (!self.paginaStatus.aberturaProcesso.representante) {
          self.paginaStatus.aberturaProcesso.representante = ''
        }
        self.paginaStatus.desabilitarEdicao = false
        self.paginaStatus.operacao = {
          descricao: 'Visualizar',
          icone: 'fa fa-search'
        }

        self.$router.push({
          name: 'aberturaProcesso',
          params: {
            paginaStatus: self.paginaStatus
          }
        })
      })
    },
    editarItem (item) {
      var self = this
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_DO_PROCESSO.concat('?codProcesso=').concat(item.aberturaProcesso.codProcesso), resposta => {
        if (resposta.body.length > 1) {
          self.arrayMovimentos = resposta.body
          self.newPaginaStatusMovimentacao.movimentacaoProcesso = item.movimentacaoProcesso
          self.modalEditar = true
        } else {
          item = item.aberturaProcesso
          self.paginaStatus.aberturaProcesso = item
          self.paginaStatus.nomeDataNascimentoDocumento = self.paginaStatus.aberturaProcesso.requerente.nomeDataNascimentoDocumento
          if (!self.paginaStatus.aberturaProcesso.representante) {
            self.paginaStatus.aberturaProcesso.representante = ''
          }
          self.paginaStatus.desabilitarEdicao = false
          self.paginaStatus.operacao = {
            descricao: 'Editar',
            icone: 'fa fa-edit'
          }

          self.$router.push({
            name: 'aberturaProcesso',
            params: {
              paginaStatus: self.paginaStatus
            }
          })
        }
      })
    },
    imprimir () {
      util.exibirToastInfo(msg.m(12))
    },
    pesquisar () {
      setTimeout(() => {
        var paginaAtual = util.recuperarDoStorage('paginaAtual')
        if (paginaAtual && paginaAtual > 1) {
          this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(util.recuperarDoStorage('paginaAtual'))
        } else {
          this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(1)
        }
      }, 500)
    },
    abrirPaginaAberturaProcessoCadastrar () {
      var newPaginaStatus = {
        aberturaProcesso: {
          formaSolicitacao: {},
          tipoProcesso: {},
          subassunto: { assunto: {} },
          roteiro: {
            setor: {
              unidade: {
                orgao: {}
              }
            }
          },
          requerente: {},
          representante: {},
          justificativa: {},
          responsavel: { usuario: {} },
          documentoNecessario: {}
        },
        requerente: {
          nacionalidade: {},
          logradouro: {},
          bairro: {},
          municipio: {},
          uf: {}
        },
        documentoAnexoProcessoSalvarList: [],
        documentoAnexoProcessoExcluirList: [],
        teste: 'teste'
      }
      newPaginaStatus.operacao = {
        descricao: 'Novo',
        icone: 'fas fa-plus'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      newPaginaStatus.modal = true
      this.$router.push({
        name: 'aberturaProcesso',
        params: {
          paginaStatus: newPaginaStatus
        }
      })
    },
    corrigirIntervaloDataFinal (data) {
      return util.corrigirIntervaloDataFinal(data)
    },
    movimentacaoSituacaoProcesso (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        movimentacaoSituacaoProcesso: {
          desabilitarEdicao: false,
          numSequencia: '',
          usuarioPortal: usuarioPortal,
          movimentacaoProcesso: {
            setorConfirmacao: { unidade: { orgao: {} } },
            aberturaProcesso: {
              tipoProcesso: {},
              subassunto: { assunto: {} },
              roteiro: {
                setor: {
                  unidade: {
                    orgao: {
                    }
                  }
                }
              },
              requerente: {}
            },
            setor: {
              unidade: {
                orgao: {
                }
              }
            },
            situacao: {}

          },
          responsavelSetor: {
            usuario: {}
          },
          situacao: {},
          codSituacaoAnterior: '',
          datMovimentacao: '',
          txtObservacao: ''
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Alterar Situação do Processo',
        icone: 'fas fa-sync'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      var filtro = '?codProcesso='.concat(item.codProcesso)
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat(filtro), resposta => {
        newPaginaStatus.movimentacaoSituacaoProcesso.movimentacaoProcesso = resposta.body
        this.$router.push({
          name: 'alteracaoSituacaoProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    observacaoGeralDoProcesso (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        observacaoGeralDoProcesso: {
          desabilitarEdicao: '',
          usuarioPortal: usuarioPortal,
          movimentacaoProcesso: {
            setorConfirmacao: { unidade: { orgao: {} } },
            aberturaProcesso: {
              tipoProcesso: {},
              subassunto: { assunto: {} },
              roteiro: {
                setor: {
                  unidade: {
                    orgao: {
                    }
                  }
                }
              },
              requerente: {}
            },
            setor: {
              unidade: {
                orgao: {
                }
              }
            },
            situacao: {}

          },
          numSequencia: '',
          txtObservacao: '',
          responsavelSetor: {
            usuario: {}
          },
          datObservacao: ''
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Observações Gerais do Processo',
        icone: 'far fa-file-alt'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      var filtro = '?codProcesso='.concat(item.codProcesso)
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat(filtro), resposta => {
        newPaginaStatus.observacaoGeralDoProcesso.movimentacaoProcesso = resposta.body
        this.$router.push({
          name: 'observacaoGeralProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    movimentacaoProcessoCadastrar (item) {
      // item = item.aberturaProcesso
      var existe = false
      var iconeMovimentar = ''
      var tituloMovimentacao = ''
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      var newPaginaStatus = {
        estorno: false,
        usuarioPortal: usuarioPortal,
        movimentacaoProcesso: {
          setor: {
            unidade: {
              orgao: {}
            }
          },
          setorConfirmacao: {
            unidade: {
              orgao: {}
            }
          },
          responsavelMovimento: {
            usuario: {}
          },
          situacao: {},
          aberturaProcesso: {
            formaSolicitacao: {},
            tipoProcesso: {},
            subassunto: { assunto: {} },
            roteiro: {},
            requerente: {},
            justificativa: {}
          }

        }
      }

      // estorno
      if (item.aberturaProcesso.confirmacaoMovimentacaoProcesso) { // ja foi movimentado e nao confirmado ainda
        if (item.aberturaProcesso.confirmacaoMovimentacaoProcesso) {
          existe = true
          iconeMovimentar = 'fas fa-undo-alt'
          tituloMovimentacao = 'Estorno de Movimentações'
        }
      } else {
        existe = false
        iconeMovimentar = 'fas fa-exchange-alt'
        tituloMovimentacao = 'Movimentar Processo'
      }

      if (existe) {
        newPaginaStatus.estorno = true
      } else {
        newPaginaStatus.estorno = false
      }
      newPaginaStatus.operacao = {
        descricao: tituloMovimentacao,
        icone: iconeMovimentar
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      newPaginaStatus.movimentacaoProcesso.aberturaProcesso = item.aberturaProcesso
      newPaginaStatus.movimentacaoProcesso.setor = item.movimentacaoProcesso.setorConfirmacao
      newPaginaStatus.movimentacaoProcesso.responsavelMovimento = item.movimentacaoProcesso.responsavelMovimento

      this.$router.push({
        name: 'movimentacaoProcesso',
        params: {
          paginaStatus: newPaginaStatus
        }
      })
    },
    confirmacaoMovimentacaoProcessoCadastrar (item) {
      item = item.aberturaProcesso
      var newPaginaStatus = {
        movimentacaoProcesso: {
          situacao: {},
          responsavelConfirmacao: {
            usuario: {}
          },
          setorConfirmacao: { unidade: { orgao: {} } },
          aberturaProcesso: {
            tipoProcesso: {},
            subassunto: { assunto: {} },
            roteiro: { setor: { unidade: { orgao: {} } } },
            requerente: {}
          }
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Confirmação de Movimentação de Processo',
        icone: 'fas fa-check-square'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      var filtro = '?codProcesso='.concat(item.codProcesso)
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat(filtro), resposta => {
        newPaginaStatus.movimentacaoProcesso = resposta.body
        newPaginaStatus.movimentacaoProcesso.txtObeservacaoConfirmacao = undefined

        this.$router.push({
          name: 'confirmacaoMovimentacaoProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    pendenciaProcessoCadastrar (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        pendenciaProcesso: {
          responsavelSetor: {
            usuario: {}
          },
          usuarioPortal: usuarioPortal,
          movimentacaoProcesso: {
            situacao: {},
            responsavelSetor: {
              usuario: {}
            },
            responsavelConfirmacao: {
              usuario: {}
            },
            setor: { unidade: { orgao: {} } },
            aberturaProcesso: {
              tipoProcesso: {},
              subassunto: { assunto: {} },
              roteiro: { setor: { unidade: { orgao: {} } } },
              requerente: {}
            }
          }
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Pendências do Processo',
        icone: 'fas fa-tasks'
      }

      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      var filtro = '?codProcesso='.concat(item.codProcesso)
      utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat(filtro), resposta => {
        newPaginaStatus.pendenciaProcesso.movimentacaoProcesso = resposta.body
        this.$router.push({
          name: 'pendenciaProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    cancelarProcessoCadastrar (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        operacao: {},
        movimentacaoProcesso: {
          aberturaProcesso: {},
          setorConfirmacao: { unidade: { orgao: {} } }
        },
        usuarioPortal: usuarioPortal
      }

      let url = api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat('?codProcesso=').concat(item.codProcesso)
      utilHttp.httpGet(url, resposta => {
        newPaginaStatus.movimentacaoProcesso = resposta.body

        newPaginaStatus.operacao = {
          descricao: 'Cancelar Processo',
          icone: 'fas fa-ban'
        }
        newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
        newPaginaStatus.desabilitarEdicao = false
        newPaginaStatus.aberturaProcesso = item
        newPaginaStatus.movimentacaoProcesso.txtObservacaoMovimento = ''
        this.$router.push({
          name: 'cancelarProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    habilitaEstornoMovimentacao (item) {
      item = item.aberturaProcesso
      var existe = false

      // ultimo
      if (item.movimentacaoRoteiroUltimo && !item.confirmacaoMovimentacaoProcesso) { // ultmo sequencia do roteiro e ja confirmado// entao nao aparece mais
        return false // caso critico
      }
      // estorno n possivel
      if (item.movimentacaoIndRetornoOrigem && item.confirmacaoMovimentacaoProcesso) { // tem flag = S e ainda nao foi confirmado
        return false // estado critico
      }

      if (item.confirmacaoMovimentacaoProcesso && item.indStatusProcesso === 'Movimentado') {
        existe = true
      }

      if (item.indStatusJuncao === 'S') {
        existe = false
      }

      return existe
    },
    habilitarMovimentacaoProcesso (item) {
      item = item.aberturaProcesso
      var existe = false
      // ultimo
      // if (item.movimentacaoRoteiroUltimo && !item.confirmacaoMovimentacaoProcesso) { // ultmo sequencia do roteiro e ja confirmado// entao nao aparece mais
      //   return false // caso critico
      // }

      if (item.indStatusProcesso === 'Aberto') {
        if (item.indStatusJuncao === 'S') {
          return false
        } else {
          return true
        }
      } else if (item.indStatusProcesso === 'Movimentado') {
        // falta implementar o responsavel

        // movimentacao
        if (!item.confirmacaoMovimentacaoProcesso) {
          existe = true
          if (item.indStatusJuncao === 'S') {
            existe = false
          }
        }
      }
      return existe
    },
    habilitarCancelamentoProcesso (item) {
      item = item.aberturaProcesso
      var existe = false
      if (item.indStatusProcesso === 'Aberto') {
        existe = true
      } else if (item.indStatusProcesso === 'Movimentado') {
        existe = true
        if (item.confirmacaoMovimentacaoProcesso) {
          if (!item.confirmacaoMovimentacaoProcesso.datConfirmacao) {
            existe = false
          }
        }
      }
      if (existe === true) {
        if (item.indStatusJuncao === 'S') {
          existe = false
        }
      }
      return existe
    },
    habilitarConfirmacaoMovimentoProcesso (item) {
      item = item.aberturaProcesso
      if (item.confirmacaoMovimentacaoProcesso) {
        if (item.indStatusProcesso === 'Movimentado' && !item.confirmacaoMovimentacaoProcesso.datConfirmacao) {
          if (item.indStatusJuncao === 'S') {
            return false
          }
          return true
        }
      }
      return false
    },
    buscarProcessosMovimentados (item) {
      item = item.aberturaProcesso
      if (item.encerramentoMovimentacaoProcesso && (item.indStatusProcesso === 'Movimentado' || item.indStatusProcesso === 'Aberto')) {
        if (item.indStatusJuncao === 'S') {
          return false
        }
        return true
      } else {
        return false
      }
    },
    buscarParametroSistema () {
      var self = this

      utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          self.parametrosSistema = resposta.body
          self.nomeComprovanteMovimento = self.parametrosSistema.nomComprovanteMovimento
        } else {
          self.nomeComprovanteMovimento = 'RelatorioComprovanteMovimentação'
        }
      })
    },
    habilitarAlterarSituacao (item) {
      item = item.aberturaProcesso
      if (item.indStatusJuncao === 'S') {
        return false
      }
      return true
    },
    buscarProcessosEncerrados (item) {
      item = item.aberturaProcesso
      if (item.indStatusProcesso === 'Encerrado') {
        if (item.indStatusJuncao === 'S') {
          return false
        }
        return true
      } else {
        return false
      }
    },
    encerramentoDoProcesso (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        operacao: {},
        movimentacaoProcesso: {
          aberturaProcesso: {},
          setorConfirmacao: { unidade: { orgao: {} } }
        },
        usuarioPortal: usuarioPortal
      }

      let url = api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat('?codProcesso=').concat(item.codProcesso)
      utilHttp.httpGet(url, resposta => {
        newPaginaStatus.movimentacaoProcesso = resposta.body

        newPaginaStatus.operacao = {
          descricao: 'Encerramento do Processo',
          icone: 'fas fa-times-circle'
        }
        newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
        newPaginaStatus.desabilitarEdicao = false
        newPaginaStatus.movimentacaoProcesso.aberturaProcesso = item
        newPaginaStatus.movimentacaoProcesso.txtObservacaoMovimento = ''
        this.$router.push({
          name: 'encerramentoMovimentacaoProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    arquivamentoDoProcesso (item) {
      item = item.aberturaProcesso
      var newPaginaStatus = {
        operacao: {},
        movimentacaoProcesso: {
          aberturaProcesso: {}
        }
      }

      let url = api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat('?codProcesso=').concat(item.codProcesso)
      utilHttp.httpGet(url, resposta => {
        newPaginaStatus.movimentacaoProcesso = resposta.body

        newPaginaStatus.operacao = {
          descricao: 'Arquivamento de Processo',
          icone: 'fas fa-archive'
        }
        newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
        newPaginaStatus.desabilitarEdicao = false
        newPaginaStatus.movimentacaoProcesso.aberturaProcesso = item
        if (newPaginaStatus.movimentacaoProcesso.setorConfirmacao !== undefined && newPaginaStatus.movimentacaoProcesso.setorConfirmacao !== '' && newPaginaStatus.movimentacaoProcesso.setorConfirmacao !== null) {
          newPaginaStatus.movimentacaoProcesso.setor = newPaginaStatus.movimentacaoProcesso.setorConfirmacao
        }
        if (newPaginaStatus.movimentacaoProcesso.responsavelConfirmacao !== undefined && newPaginaStatus.movimentacaoProcesso.responsavelConfirmacao !== '' && newPaginaStatus.movimentacaoProcesso.responsavelConfirmacao !== null) {
          newPaginaStatus.movimentacaoProcesso.responsavelMovimento = newPaginaStatus.movimentacaoProcesso.responsavelConfirmacao
        }

        newPaginaStatus.movimentacaoProcesso.setorConfirmacao = { unidade: { orgar: {} } }
        newPaginaStatus.movimentacaoProcesso.responsavelConfirmacao = { usuario: {} }
        newPaginaStatus.movimentacaoProcesso.txtObservacaoMovimento = ''
        this.$router.push({
          name: 'arquivarProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    anexarDocumentoProcesso (item) {
      let usuarioPortalVazio = {
        txtEmail: '',
        numTelefoneMovel: '',
        numTelefoneComercial: ''
      }
      let usuarioPortal = item.usuarioPortalServico !== null ? item.usuarioPortalServico.usuarioPortal : usuarioPortalVazio
      item = item.aberturaProcesso
      var newPaginaStatus = {
        movimentacaoProcesso: {},
        usuarioPortal: usuarioPortal,
        documentoAnexoProcesso: {
          aberturaProcesso: item,
          responsavelSetor: {},
          documento: {}
        }
      }

      let url = api.BUSCAR_MOVIMENTACAO_A_CONFIRMAR.concat('?codProcesso=').concat(item.codProcesso)
      utilHttp.httpGet(url, resposta => {
        newPaginaStatus.movimentacaoProcesso = resposta.body
        newPaginaStatus.operacao = {
          descricao: 'Anexar Documentos',
          icone: 'fas fa-paperclip'
        }
        newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
        newPaginaStatus.desabilitarEdicao = false
        this.$router.push({
          name: 'documentoAnexoProcesso',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    tratarDataInicial () {
      var self = this

      if (self.datAtualizacao !== null && self.datAtualizacao !== undefined && self.datAtualizacao !== '') {
        let di = new Date(util.formatarAnoMesDia(self.datAtualizacao, 'DD/MM/YYYY'))
        let dia = String(di.getDate()).padStart(2, '0')
        let mes = String(di.getMonth() + 1).padStart(2, '0')
        let ano = String(di.getFullYear())

        var dInicial = ano + '-' + mes + '-' + dia

        self.dataInicial = dInicial
      }
    },
    tratarDataFinal () {
      var self = this

      if (self.datAtualizacaoFinal !== null && self.datAtualizacaoFinal !== undefined && self.datAtualizacaoFinal !== '') {
        let df = new Date(util.formatarAnoMesDia(self.datAtualizacaoFinal, 'DD/MM/YYYY'))
        let dia = String(df.getDate()).padStart(2, '0')
        let mes = String(df.getMonth() + 1).padStart(2, '0')
        let ano = String(df.getFullYear())

        var dFinal = ano + '-' + mes + '-' + dia

        self.dataFinal = dFinal
      }
    },
    carregamentoInicial () {
      var self = this
      var data = new Date()

      self.datAtualizacao = '01/01/'.concat(data.getFullYear())

      var datAtual = new Date()

      self.datAtualizacaoFinal = util.formatarDiaMesAno(datAtual.toJSON()) // `${ultimaDataMes.getUTCDay()}/${ultimaDataMes.getUTCMonth()}/${ultimaDataMes.getFullYear()}`
      self.aberturaProcesso.anoProcesso = new Date().getFullYear()
      self.anoProcessoFinal = new Date().getFullYear()
      // self.pesquisar()
      self.buscarParametroSistema()
      if (util.recuperarDoStorage('pesquisarPaginaAbertura') === 'S') {
        this.pesquisar()
      }

      self.carregarFiltros()
    },
    diasNoMes (month, year) {
      return new Date(year, month, 0).getDate()
    },
    // pendenteConfirmacao () {
    //   this.indPendenteConfirmacao = true
    //   this.pesquisar()
    // },
    getValorFiltroURLRecursivo (filtroURL, parametro) {
      var valor = null
      if (filtroURL) {
        filtroURL.split('&').forEach(p => {
          if (p.split('=')[0].toString() === parametro.toString()) {
            valor = p.split('=')[1]
          }
        })
        return valor
      } else {
        return ''
      }
    },
    carregarFiltros () {
      this.$nextTick(() => {
        setTimeout(() => {
          var self = this
          var filtro = util.recuperarDoStorage('filtroAberturaProcesso')
          console.log(filtro)
          if (filtro) {
            var numProcesso = self.getValorFiltroURLRecursivo(filtro, 'numProcesso')
            var numProcessoFinal = self.getValorFiltroURLRecursivo(filtro, 'numProcessoFinal')
            var datAtualizacao = self.getValorFiltroURLRecursivo(filtro, 'datAtualizacao')
            var datAtualizacaoFinal = self.getValorFiltroURLRecursivo(filtro, 'datAtualizacaoFinal')
            var indStatusProcesso = self.getValorFiltroURLRecursivo(filtro, 'indStatusProcesso')
            var txtNotaFiscal = self.getValorFiltroURLRecursivo(filtro, 'txtNotaFiscal')
            var codRequerente = self.getValorFiltroURLRecursivo(filtro, 'codRequerente')
            var nomRequerente = self.getValorFiltroURLRecursivo(filtro, 'nomRequerente')
            var codSituacao = self.getValorFiltroURLRecursivo(filtro, 'codSituacao')
            var desSituacao = self.getValorFiltroURLRecursivo(filtro, 'desSituacao')
            // var codUsuario = self.getValorFiltroURLRecursivo(filtro, 'codUsuario')
            var codAssunto = self.getValorFiltroURLRecursivo(filtro, 'codAssunto')
            var desAssunto = self.getValorFiltroURLRecursivo(filtro, 'desAssunto')
            var codSubassunto = self.getValorFiltroURLRecursivo(filtro, 'codSubassunto')
            var desSubassunto = self.getValorFiltroURLRecursivo(filtro, 'desSubassunto')
            var indPendenteConfirmacao = self.getValorFiltroURLRecursivo(filtro, 'pendenteConfirmacao')

            self.aberturaProcesso.numProcesso = numProcesso || ''
            setTimeout(() => {
              self.numProcessoFinal = numProcessoFinal || ''
            }, 100)
            self.datAtualizacao = util.formatarDiaMesAno(datAtualizacao)
            self.datAtualizacaoFinal = util.formatarDiaMesAno(datAtualizacaoFinal)
            self.aberturaProcesso.txtNotaFiscal = txtNotaFiscal

            if (indStatusProcesso) {
              self.StatusProcesso = []
              indStatusProcesso.split(',').forEach(s => {
                if (!self.StatusProcesso.includes(s)) {
                  self.StatusProcesso.push(s)
                }
              })
              this.alterouStatusProcesso()
            }

            if (codSituacao && desSituacao) {
              this.$refs['refSituacao'].carregar(codSituacao, desSituacao)
            }

            if (codAssunto && desAssunto) {
              this.$refs['refAssunto'].carregar(codAssunto, desAssunto)
            }

            if (codSubassunto && desSubassunto) {
              this.$refs['refSubAssunto'].carregar(codSubassunto, desSubassunto)
            }

            if (codRequerente && nomRequerente) {
              this.$refs['refRequerente'].carregar(codRequerente, nomRequerente)
            }
            self.indPendenteConfirmacao = indPendenteConfirmacao === 'S'
          }
        }, 100)
      })

      // if (self.aberturaProcesso.numProcesso) filtro = filtro.concat('&numProcesso=').concat(self.aberturaProcesso.numProcesso)
      // if (self.numProcessoFinal) filtro = filtro.concat('&numProcessoFinal=').concat(self.numProcessoFinal)

      // if (self.datAtualizacao) filtro = filtro.concat('&datAtualizacao=').concat(self.dataInicial).concat('T00:00:00.000-00:00')
      // if (self.datAtualizacaoFinal) filtro = filtro.concat('&datAtualizacaoFinal=').concat(self.dataFinal).concat('T23:59:59.999-05:00')

      // if (self.aberturaProcesso.indStatusProcesso !== 'TOD') {
      //   if (self.aberturaProcesso.indStatusProcesso) filtro = filtro.concat('&indStatusProcesso=').concat(self.aberturaProcesso.indStatusProcesso)
      // }

      // if (self.aberturaProcesso.txtNotaFiscal) filtro = filtro.concat('&txtNotaFiscal=').concat(self.aberturaProcesso.txtNotaFiscal)

      // // requerente e situação
      // if (self.aberturaProcesso.requerente.codRequerente) filtro = filtro.concat('&codRequerente=').concat(self.aberturaProcesso.requerente.codRequerente)
      // if (self.desSituacao !== '') {
      //   if (self.desSituacao) filtro = filtro.concat('&desSituacao=').concat(self.desSituacao)
      // }
      // if (self.$login.getCodUsuario()) filtro = filtro.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      // if (self.aberturaProcesso.codAssunto) filtro = filtro.concat('&codAssunto=').concat(self.aberturaProcesso.codAssunto)
      // if (self.aberturaProcesso.codSubassunto) filtro = filtro.concat('&codSubassunto=').concat(self.aberturaProcesso.codSubassunto)

      // if (self.indPendenteConfirmacao) {
      //   filtro = filtro.concat('&pendenteConfirmacao=S')
      //   self.indPendenteConfirmacao = false
      // }
    },
    alterouNumProcesso () {
      this.numProcessoFinal = this.aberturaProcesso.numProcesso
    },
    alterouStatusProcesso () {
      var statusProcesso = ''

      // if (this.StatusProcesso.includes('TOD')) {
      //   this.StatusProcesso = ['TOD']
      // }
      this.StatusProcesso.forEach(status => {
        statusProcesso = statusProcesso.concat(status.concat(','))
      })
      this.aberturaProcesso.indStatusProcesso = statusProcesso.slice(0, -1)
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    'aberturaProcesso.codSubassunto': {
      handler (valor) {
        var self = this
        if (valor) {
          if (self.$refs['refSubAssunto'].objetoSelecionado.codSubassunto) {
            if (!self.$refs['refAssunto'].objetoSelecionado.codAssunto) {
              let subassunto = self.$refs['refSubAssunto'].objetoSelecionado
              self.aberturaProcesso.codAssunto = subassunto.assunto.codAssunto
              self.$refs['refAssunto'].carregar(subassunto.assunto.codAssunto, subassunto.assunto.desAssunto, subassunto.assunto)
            }
          }
        }
      }
    },
    'aberturaProcesso.codAssunto': {
      handler (valor) {
        var self = this
        if (!util.validarCampo(valor)) {
          self.$refs['refSubAssunto'].limpar()
        }
      }
    }
  },
  mounted () {
    var self = this
    self.paginaStatus.caminhoMigalha = [
      {
        icone: 'fas fa-folder-open',
        descricao: 'Processo',
        rotaNome: 'aberturaProcessoPesquisa'
      }
    ]
    self.buscarParametrosSistema()
    self.carregamentoInicial()
    self.permissaoPerfil = util.montarPermissoes(self.$router.history.current.path)
  },
  components: { GBreadcrumb, GPesquisa, GSelect, GInput, GDatepicker, GAutocomplete, GFab, GDateInput }
}
</script>
